import React from "react";
import I18n from 'i18n.js.erb'


// Figma: ogni voce ha la sua spunta. Solo l'indirizzo occupa più righe sotto la stessa spunta,
// per cui una voce è sempre un elenco di righe
const ConfirmationRow = ({ title, entries }) => {

  return <div className="slx-form__section">
    <h2 className="slx-form__section-title">{title}</h2>
    {entries.map((lines, entryIndex) =>
      <div className="slx-recap__row" key={entryIndex}>
        <img src={window.location.origin + '/images/icons/confirmation.svg'} alt="" />
        <p className="slx-recap__text">
          {lines.map((line, index) => <React.Fragment key={line}>{index > 0 && <br />}{line}</React.Fragment>)}
        </p>
      </div>
    )}
  </div>
};


// Figma: quando le carte sono già in sede il riepilogo mostra anche l'indirizzo a cui tornano
const recipientEntries = (address, countryName, orderNumber, cardsReceived) => {
  const fullName = [address.first_name, address.last_name].filter(Boolean).join(' ');
  const orderLine = I18n.t('js.submissionListWithdrawalPage.recap.orderNumber', { number: orderNumber });
  const emailLine = I18n.t('js.submissionListWithdrawalPage.recap.email', { email: address.email });

  if (!cardsReceived)
    return [[fullName], [emailLine], [orderLine]];

  return [
    [fullName],
    [
      address.co,
      [address.street_square, address.number, address.indoor].filter(Boolean).join(' '),
      `${address.cap} ${address.city} - ${address.province} (${(countryName || '').toUpperCase()})`
    ].filter(Boolean),
    [I18n.t('js.submissionListWithdrawalPage.recap.phone', { phone: address.phone_number })],
    [emailLine],
    [orderLine]
  ];
};


const SubmissionListWithdrawalConfirmation = ({
  reasonLabel,
  explanation,
  refundMethodLabel,
  bankDetails,
  address,
  countryName,
  orderNumber,
  cardsReceived,
  termsAccepted,
  termsError,
  onTermsChange,
  onBack,
  onConfirm,
  submitting,
  submitError
}) => {

  const termsUrl = `/${I18n.locale}/grading_service_terms_of_use.html#withdrawal`;

  return (
    <div className="slx-form">
      <div className="slx-form__card">
        <div className="slx-form__sections">
          <ConfirmationRow title={I18n.t('js.submissionListWithdrawalPage.recap.reasonTitle')} entries={[[reasonLabel], [explanation]]} />
          <ConfirmationRow title={I18n.t('js.submissionListWithdrawalPage.recap.refundTitle')} entries={[[refundMethodLabel]]} />
          {
            /* rimborso per bonifico: il cliente riconferma le coordinate su cui tornano i soldi */
            bankDetails &&
              <ConfirmationRow
                title={I18n.t('js.submissionListWithdrawalPage.recap.bankDetailsTitle')}
                entries={[[bankDetails.accountHolder, bankDetails.iban, bankDetails.swift].filter(Boolean)]}
              />
          }
          <ConfirmationRow
            title={I18n.t('js.submissionListWithdrawalPage.yourDataTitle')}
            entries={recipientEntries(address, countryName, orderNumber, cardsReceived)}
          />
        </div>

        <div className="slx-recap__terms">
          <label className="slx-recap__terms-label">
            <input
              type="checkbox"
              className={`slx-recap__checkbox ${termsError ? 'slx-recap__checkbox--error' : ''}`}
              checked={termsAccepted}
              onChange={(event) => onTermsChange(event.target.checked)}
            />
            <span>
              {I18n.t('js.submissionListWithdrawalPage.recap.termsIntro')}
              &nbsp;
              <a href={termsUrl} target="_blank" className="slx-link">{I18n.t('js.submissionListWithdrawalPage.recap.termsLink')}</a>.
            </span>
          </label>
          {termsError && <p className="slx-form__error">{I18n.t('js.submissionListWithdrawalPage.recap.termsRequired')}</p>}
        </div>

        {submitError && <p className="slx-form__error">{submitError}</p>}

        <div className="slx-form__footer">
          <button type="button" className="slx-form__back" onClick={onBack}>
            <i className="fas fa-chevron-left" />
            {I18n.t('js.submissionListWithdrawalPage.back')}
          </button>

          <button type="button" className="slx-pill slx-pill--flat" disabled={submitting} onClick={onConfirm}>
            {I18n.t('js.submissionListWithdrawalPage.recap.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionListWithdrawalConfirmation;
